//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Group from "./Group.vue";
import Item from "./Item.vue";
export default {
  name: "BlueFilters",
  components: { Group, Item }, data() {
    return {
      mobileDrawerOpen: false,
    };
  },
  computed: {
    filters() {
      return this.$store.getters.filters.filter((g) =>
        g.visible ? true : g.filters.some((f) => f.selected)
      );
    },
    extended() {
      return this.$store.getters.extended;
    },
  },
  methods: {
    clearAllFilters() {
      this.$store.dispatch("removeAllTags");
    },
    toggleMobileDrawer(toggle = !this.mobileDrawerOpen) {
      this.mobileDrawerOpen = toggle;
    },
    setFilterValue(filter, val, callback) {
      let value;
      if (typeof val === "object") value = val.target.value;
      else value = val;
      this.$store.commit("setFilterValue", { filter, value });
      if (this.options.filterAutoSubmit) return this.executeSearch(callback);
    },
    extend(callback) {
      this.$store.commit("extend", callback);
    },
    executeSearch(callback) {
      if (this.options.preserveResults) this.$store.commit("clearPreviousItemResults");
      return this.$store.dispatch("executeSearch", callback);
    },
  },
};
